import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import DashboardLayout from "../../DashboardLayout";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { fetchAdsCountByPlatform } from "../../../services/axios/apiManager";
import { handleErrors } from "../../../services/dataManager";
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

function UserDemographics() {
  const tableRef = useRef(null);

  const navigation = useNavigate();
  const [tableData, setTableData] = useState([]);

  const getAdsCountByPlatform = async () => {
    const res = await fetchAdsCountByPlatform();
    if (res?.data?.success && res?.data?.data) {
      setTableData(res.data.data);
    } else {
      handleErrors(res, navigation);
    }
  };

  const chartData = {
    labels: tableData.map((item) => item.platform),
    datasets: [
      {
        label: "Ad Engagement (%)",
        data: tableData.map((item) => item.total_ads),
        backgroundColor: "rgba(153, 102, 255, 0.7)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { labels: { color: "#fff" } },
    },
    scales: {
      x: { ticks: { color: "#fff" } },
      y: { beginAtZero: true, ticks: { color: "#fff" } },
    },
  };

  useEffect(() => {
    getAdsCountByPlatform();
  }, []);

  useEffect(() => {
    const $table = $(tableRef.current);
    const rows = tableData?.map((item) => {
      return [item?.platform, item?.total_ads];
    });

    const config = {
      data: rows,
      columns: [{ title: "Platform" }, { title: "Total Ads" }],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
    };

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(rows).draw();
    } else {
      $table.DataTable(config);
    }
    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [tableData]);
  return (
    <DashboardLayout>
      {/* Filter Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">Filter by Demographics</h5>
        </div>
      </div>

      {/* Table Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h5 className="card-title">User Demographics</h5>
          <p className="card-text">
            Age, gender, and device type affecting ad engagement.
          </p>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="table table-dark table-striped table-hover w-100"
            />
            {tableData?.length === 0 && (
              <p className="text-center mt-3">No data available.</p>
            )}
          </div>
        </div>
      </div>

      {/* Chart Card */}
      <div className="card bg-dark text-white mt-3">
        <div className="card-body">
          <h6 className="mb-3">Ad Engagement by Demographics</h6>
          <Bar data={chartData} options={chartOptions} />
          {tableData?.length === 0 && (
            <p className="text-center mt-3">No data available.</p>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
}

export default UserDemographics;
